<script lang="ts">
  import { useConsoleArt } from "$lib/core/ConsoleArt.svelte.ts";
  import { useScrollHashIntoView } from "$lib/core/HashNavigation";
  import Footer from "$lib/design-systems/product/patterns/Footer.svelte";
  import StickyHeader from "$routes/(docs)/docs/_components/StickyHeader.svelte";
  import DocsNavbar from "./_components/docs-navbar/DocsNavbar.svelte";

  useConsoleArt();

  useScrollHashIntoView();
</script>

<div class="flex min-h-screen flex-col">
  <StickyHeader>
    <DocsNavbar />
  </StickyHeader>
  <slot />
  <Footer />
</div>
